import React, { RefObject } from "react";

export const FOCUSABLE = [
    "a[href]:not(form *)",
    "button:not([disabled]):not(form *)",
    "form[tabindex='0']",
].join(", ");

/**
 * Arrow/Home/End keyboard navigation for submenu and search panels.
 *
 * Elements inside a <form> are excluded so that arrow keys work
 * naturally for text editing in the search input.
 */
export function useSubpanelKeyboardNav(
    panelRef: RefObject<HTMLDivElement | null>,
) {
    const onKeyDown = (event: React.KeyboardEvent) => {
        /* v8 ignore if -- @preserve */
        if (!panelRef.current) return;

        const focusable = Array.from(
            panelRef.current.querySelectorAll<HTMLElement>(FOCUSABLE),
        );
        if (focusable.length === 0) return;

        const currentIndex = focusable.indexOf(
            document.activeElement as HTMLElement,
        );
        if (currentIndex === -1) return;

        let nextIndex: number | null = null;

        switch (event.key) {
            case "ArrowDown":
            case "ArrowRight":
                nextIndex = (currentIndex + 1) % focusable.length;
                break;
            case "ArrowUp":
            case "ArrowLeft":
                nextIndex =
                    (currentIndex - 1 + focusable.length) % focusable.length;
                break;
            case "Home":
                nextIndex = 0;
                break;
            case "End":
                nextIndex = focusable.length - 1;
                break;
        }

        /* v8 ignore else -- @preserve */
        if (nextIndex !== null) {
            event.preventDefault();
            focusable[nextIndex].focus();
        }
    };

    return { onKeyDown };
}
